import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Empty, Loader } from "@/components/Page";

import { WikiArticleCard } from "@/components/wiki/WikiArticleCard";
import { WikiChrome } from "@/components/wiki/WikiChrome";
import { WikiSearchBar } from "@/components/wiki/WikiSearchBar";

export default function WikiSearch() {
  const [params] = useSearchParams();
  const query = params.get("q") || "";
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/wiki/search?q=${encodeURIComponent(query)}`).then((res) => setData(res.data)).catch((error) => {
      toast.error(apiErr(error));
      setData({ query, results: [], categories: [] });
    });
  }, [query]);

  if (data === null) return <Loader label="Searching the archives…" />;

  return (
    <WikiChrome title="Search the Wiki" subtitle={query ? `Showing archive matches for “${query}”.` : "Use the search bar to find articles, systems, and basics."} categories={data.categories}>
      <section className="border border-amber-900/20 bg-zinc-950/55 p-5 sm:p-6">
        <WikiSearchBar initialValue={query} />
      </section>
      {query && data.results.length === 0 ? <Empty label="No published articles matched your search yet." /> : query ? <div className="grid gap-4 md:grid-cols-2">{data.results.map((article) => <WikiArticleCard key={article.id} article={article} />)}</div> : <Empty label="Search the codex by title, summary, or article text." />}
    </WikiChrome>
  );
}